"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.srmToCss = exports.srmToRgb = exports.calcColor = void 0;
const utils_1 = require("./utils");
const units_1 = require("./units");
// MCU = (weight of grain in lbs)*(color of grain in lovibond) / (volume in gal) SRM = 1.4922 * MCU ^ 0.6859
const mcu2srm = (mcu) => 1.4922 * Math.pow(mcu, 0.6859);
const calcMCU = (amount, color) => color > 0.56 ? amount * color : 0;
const calcColor = (fermentables, postBoilVolume) => {
    const fermentablesMCU = fermentables.map((fermentable) => {
        return calcMCU(units_1.convertMeasurableValue(fermentable.amount, 'lb'), units_1.convertMeasurableValue(fermentable.color, 'Lovi'));
    });
    const colorSRM = mcu2srm(utils_1.sum(fermentablesMCU) / units_1.convertMeasurableValue(postBoilVolume, 'gal'));
    return {
        unit: 'SRM',
        value: colorSRM,
    };
};
exports.calcColor = calcColor;
const srmToRgb = (srm) => ({
    r: Math.round(Math.min(255, Math.max(0, 255 * Math.pow(0.975, srm)))),
    g: Math.round(Math.min(255, Math.max(0, 255 * Math.pow(0.88, srm)))),
    b: Math.round(Math.min(255, Math.max(0, 255 * Math.pow(0.7, srm)))),
});
exports.srmToRgb = srmToRgb;
const srmToCss = (srm) => {
    const color = exports.srmToRgb(srm);
    return `rgb(${color.r}, ${color.g}, ${color.b})`;
};
exports.srmToCss = srmToCss;
//# sourceMappingURL=color.js.map